export default __webpack_public_path__ + "static/whatsapp-qr-code-b491040b8e497c2eaa39a6914771be0f.png";